import React from 'react';
import PropTypes from 'prop-types';
import { Radio, Table, Button, Space } from 'antd';
import { InfoCircleOutlined, SettingOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';

const Card = ({
  columns, data, header, route, onChange, selectedRadio, btnInfo, showPrivilegesBtn, onInfo
}) => {
  const { pathname } = useLocation();
  const handleChange = (e) => {
    onChange('sensor', e.target.value);
  };
  return (
    <div className="card-container">
      <div className="card-container__header">
        <p>{header}</p>
        <div className="card-container__header-object">
          {window.screen.width < 600
            && (
              <div>
                {pathname.includes('info-grafica')
                  ? (
                    <div>
                      <Radio checked={selectedRadio === data[0]._id} value={data[0]._id} onChange={handleChange} buttonStyle="solid" />
                    </div>
                  )
                  : (
                    <div>
                      <Space>
                        {showPrivilegesBtn && (
                          <Link to={`/usuario/${data[0]._id}/privilegios`}>
                            <Button 
                              type="primary" 
                              icon={<SettingOutlined />} 
                              size="middle"
                              shape="round"
                              title="Gestionar Privilegios"
                              className="privilege-btn-mobile"
                            />
                          </Link>
                        )}
                        {onInfo ? (
                          <span
                            style={{ cursor: 'pointer' }}
                            onClick={onInfo}
                            role="button"
                            tabIndex={0}
                            onKeyDown={e => (e.key === 'Enter' || e.key === ' ') ? onInfo(e) : null}
                            aria-label="Ver información de la tarjeta"
                          >
                            <InfoCircleOutlined />
                          </span>
                        ) : (
                          <Link to={`/${route}/${data[0]._id}`}>
                            <InfoCircleOutlined />
                          </Link>
                        )}
                      </Space>
                    </div>
                  )}
              </div>
            )}
        </div>
      </div>
      <div className="card-container__body">
        <div className="card-container__table">
          <Table
            columns={columns}
            dataSource={data}
            pagination={false}
            size="small"
          />
        </div>
        {window.screen.width > 600
          && (
            <>
              {pathname.includes('info-grafica')
                ? (
                  <div className="card-container__radio">
                    <Radio checked={selectedRadio === data[0]._id} value={data[0]._id} onChange={handleChange} buttonStyle="solid" />
                  </div>
                )
                : (
                  (btnInfo === true && (
                  <div className="card-container__info">
                    <Space>
                      {showPrivilegesBtn && (
                        <Link to={`/usuario/${data[0]._id}/privilegios`}>
                          <Button 
                            type="primary" 
                            icon={<SettingOutlined />} 
                            size="middle"
                            title="Gestionar Privilegios"
                            className="privilege-btn-desktop"
                          >
                            Privilegios
                          </Button>
                        </Link>
                      )}
                      {onInfo ? (
                        <span
                          style={{ cursor: 'pointer' }}
                          onClick={onInfo}
                          role="button"
                          tabIndex={0}
                          onKeyDown={e => (e.key === 'Enter' || e.key === ' ') ? onInfo(e) : null}
                          aria-label="Ver información de la tarjeta"
                        >
                          <InfoCircleOutlined />
                        </span>
                      ) : (
                        <Link to={`/${route}/${data[0]._id}`}>
                          <InfoCircleOutlined />
                        </Link>
                      )}
                    </Space>
                  </div>
                  ))
                )}
            </>
          )}
      </div>
    </div>
  );
};

Card.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.objectOf).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string
  })).isRequired,
  header: PropTypes.string.isRequired,
  route: PropTypes.string,
  onChange: PropTypes.func,
  selectedRadio: PropTypes.string,
  btnInfo: PropTypes.bool,
  showPrivilegesBtn: PropTypes.bool,
  onInfo: PropTypes.func
};
Card.defaultProps = {
  onChange: () => { },
  selectedRadio: '',
  btnInfo: true,
  route: '',
  showPrivilegesBtn: false,
  onInfo: undefined
};

export default Card;
